import React, { useEffect, useState } from "react";
import reservereq from "../../../../assets/img/dashboard/reserv-request.svg";
import cashpayment from "../../../../assets/img/dashboard/payment.svg";
import chat from "../../../../assets/img/dashboard/chat.svg";
import support from "../../../../assets/img/dashboard/support.svg";
import profile from "../../../../assets/img/Home/profile.png";
import img from "../../../../assets/img/Home/cover-img (2).png";
import useFetch from "../../../../hooks/useAxios";
const NotidicationCard = ({ info }) => {

  
  return (
    <div className="NotidicationCard">
      <div className="flex gap-[21px] items-center">
      <div className="relative profile-box">
        <img className="profile-box-img" src={info.user.avatar} />
  { (info.type === "reserve" || info.type === "report")?     <img className="profile-box-noticon" src={reservereq} />:
  
  
  info.type === "payment" ?  <img className="profile-box-noticon" src={cashpayment} />:
  info.type === "residence_update" ?  <img className="profile-box-noticon" src={support} />:
  info.type === "comment" ?  <img className="profile-box-noticon" src={chat} />:null
  
  }
      </div>
      <div className="NotidicationCard--info">
        <h5>
            {info.user.full_name}
           <span> ۱۰  دقیقه پیش</span>
        </h5>
        <p>
         {info.subject}
        </p>
      </div>
      </div>
      <img className="NotidicationCard--img" src={img} />
    </div>
  );
};

export default NotidicationCard;
